import React, { useState, useEffect, useRef } from 'react';
import { getTranslationStatusOption } from '../../utils/translationAdminStatus';

// Countries organized by continent
const COUNTRIES_BY_CONTINENT = {
  'Africa': [
    'Algeria', 'Angola', 'Benin', 'Botswana', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cameroon', 
    'Central African Republic', 'Chad', 'Comoros', 'Congo', 'Côte d\'Ivoire', 'Djibouti', 'Egypt', 
    'Equatorial Guinea', 'Eritrea', 'Eswatini', 'Ethiopia', 'Gabon', 'Gambia', 'Ghana', 'Guinea', 
    'Guinea-Bissau', 'Kenya', 'Lesotho', 'Liberia', 'Libya', 'Madagascar', 'Malawi', 'Mali', 
    'Mauritania', 'Mauritius', 'Morocco', 'Mozambique', 'Namibia', 'Niger', 'Nigeria', 'Rwanda', 
    'São Tomé and Príncipe', 'Senegal', 'Seychelles', 'Sierra Leone', 'Somalia', 'South Africa', 
    'South Sudan', 'Sudan', 'Tanzania', 'Togo', 'Tunisia', 'Uganda', 'Zambia', 'Zimbabwe'
  ],
  'Asia': [
    'Afghanistan', 'Armenia', 'Azerbaijan', 'Bahrain', 'Bangladesh', 'Bhutan', 'Brunei', 'Cambodia', 
    'China', 'Cyprus', 'Georgia', 'India', 'Indonesia', 'Iran', 'Iraq', 'Israel', 'Japan', 'Jordan', 
    'Kazakhstan', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Lebanon', 'Malaysia', 'Maldives', 'Mongolia', 
    'Myanmar', 'Nepal', 'North Korea', 'Oman', 'Pakistan', 'Palestine', 'Philippines', 'Qatar', 
    'Russia', 'Saudi Arabia', 'Singapore', 'South Korea', 'Sri Lanka', 'Syria', 'Taiwan', 'Tajikistan', 
    'Thailand', 'Timor-Leste', 'Turkey', 'Turkmenistan', 'United Arab Emirates', 'Uzbekistan', 
    'Vietnam', 'Yemen'
  ],
  'Europe': [
    'Albania', 'Andorra', 'Austria', 'Belarus', 'Belgium', 'Bosnia and Herzegovina', 'Bulgaria', 
    'Croatia', 'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 
    'Hungary', 'Iceland', 'Ireland', 'Italy', 'Latvia', 'Liechtenstein', 'Lithuania', 'Luxembourg', 
    'Malta', 'Moldova', 'Monaco', 'Montenegro', 'Netherlands', 'North Macedonia', 'Norway', 'Poland', 
    'Portugal', 'Romania', 'Russia', 'San Marino', 'Serbia', 'Slovakia', 'Slovenia', 'Spain', 
    'Sweden', 'Switzerland', 'Ukraine', 'United Kingdom', 'Vatican City'
  ],
  'North America': [
    'Antigua and Barbuda', 'Bahamas', 'Barbados', 'Belize', 'Canada', 'Costa Rica', 'Cuba', 
    'Dominica', 'Dominican Republic', 'El Salvador', 'Grenada', 'Guatemala', 'Haiti', 'Honduras', 
    'Jamaica', 'Mexico', 'Nicaragua', 'Panama', 'Saint Kitts and Nevis', 'Saint Lucia', 
    'Saint Vincent and the Grenadines', 'Trinidad and Tobago', 'United States'
  ],
  'South America': [
    'Argentina', 'Bolivia', 'Brazil', 'Chile', 'Colombia', 'Ecuador', 'Guyana', 'Paraguay', 
    'Peru', 'Suriname', 'Uruguay', 'Venezuela'
  ],
  'Oceania': [
    'Australia', 'Fiji', 'Kiribati', 'Marshall Islands', 'Micronesia', 'Nauru', 'New Zealand', 
    'Palau', 'Papua New Guinea', 'Samoa', 'Solomon Islands', 'Tonga', 'Tuvalu', 'Vanuatu'
  ]
};

// Comprehensive list of languages
const ALL_LANGUAGES = [
  'Afrikaans', 'Albanian', 'Amharic', 'Arabic', 'Armenian', 'Azerbaijani', 'Basque', 'Belarusian', 
  'Bengali', 'Bosnian', 'Bulgarian', 'Burmese', 'Catalan', 'Cebuano', 'Chinese (Simplified)', 
  'Chinese (Traditional)', 'Croatian', 'Czech', 'Danish', 'Dutch', 'English - International','English - UK','English - USA', 'Esperanto', 
  'Estonian', 'Filipino', 'Finnish', 'French', 'Galician', 'Georgian', 'German', 'Greek', 
  'Gujarati', 'Haitian Creole', 'Hausa', 'Hebrew', 'Hindi', 'Hmong', 'Hungarian', 'Icelandic', 
  'Igbo', 'Indonesian', 'Irish', 'Italian', 'Japanese', 'Javanese', 'Kannada', 'Kazakh', 'Khmer', 
  'Korean', 'Kurdish', 'Kyrgyz', 'Lao', 'Latvian', 'Lithuanian', 'Luxembourgish', 'Macedonian', 
  'Malagasy', 'Malay', 'Malayalam', 'Maltese', 'Maori', 'Marathi', 'Mongolian', 'Nepali', 
  'Norwegian', 'Nyanja', 'Pashto', 'Persian', 'Polish', 'Portuguese', 'Punjabi', 'Romanian', 
  'Russian', 'Samoan', 'Scottish Gaelic', 'Serbian', 'Shona', 'Sindhi', 'Sinhala', 'Slovak', 
  'Slovenian', 'Somali', 'Spanish', 'Sundanese', 'Swahili', 'Swedish', 'Tagalog', 'Tajik', 
  'Tamil', 'Telugu', 'Thai', 'Turkish', 'Ukrainian', 'Urdu', 'Uzbek', 'Vietnamese', 'Welsh', 
  'Xhosa', 'Yiddish', 'Yoruba', 'Zulu'
];

const AddTranslationModal = ({ isOpen, onClose, onAdd, editingTranslation, currentCoaName }) => {
  const [coaName, setCoaName] = useState('');
  const [localeTag, setLocaleTag] = useState('');
  const [territory, setTerritory] = useState('');
  const [isSourceVersion, setIsSourceVersion] = useState(false);
  const [continent, setContinent] = useState('');
  const [country, setCountry] = useState('');
  const [language, setLanguage] = useState('');
  const [translationDate, setTranslationDate] = useState('');
  const [status, setStatus] = useState('In Development');
  const [author, setAuthor] = useState('');
  const [fundedBy, setFundedBy] = useState('');
  const [method, setMethod] = useState('');
  const [paymentType, setPaymentType] = useState('free'); // 'paid' or 'free'
  const [fee, setFee] = useState('');
  const [isLocked, setIsLocked] = useState(false);
  const [certified, setCertified] = useState(false);
  const [translationFile, setTranslationFile] = useState(null);
  const [methodologyFile, setMethodologyFile] = useState(null);
  const [availableCountries, setAvailableCountries] = useState([]);
  const [isDraggingTranslation, setIsDraggingTranslation] = useState(false);
  const [isDraggingMethodology, setIsDraggingMethodology] = useState(false);

  const translationInputRef = useRef(null);
  const methodologyInputRef = useRef(null);

  const existingTranslationFileUrl = editingTranslation?.translationFileUrl || editingTranslation?.translationFile?.url || '';
  const existingMethodologyFileUrl = editingTranslation?.methodologyFileUrl || editingTranslation?.methodologyFile?.url || '';

  // Update available countries when continent changes
  useEffect(() => {
    if (continent && COUNTRIES_BY_CONTINENT[continent]) {
      const countries = COUNTRIES_BY_CONTINENT[continent];
      setAvailableCountries(countries);
      // Reset country if it's not in the new continent's list
      setCountry(prevCountry => {
        if (prevCountry && !countries.includes(prevCountry)) {
          return '';
        }
        return prevCountry;
      });
    } else {
      setAvailableCountries([]);
      if (continent === '') {
        setCountry('');
      }
    }
  }, [continent]);

  // Load translation data when editing
  useEffect(() => {
    if (editingTranslation) {
      setCoaName(editingTranslation.coaName || currentCoaName || '');
      setLocaleTag(editingTranslation.localeTag || '');
      setTerritory(editingTranslation.territory || '');
      setIsSourceVersion(editingTranslation.isSourceVersion || false);
      setContinent(editingTranslation.continent || '');
      setCountry(editingTranslation.country || '');
      setLanguage(editingTranslation.language || '');
      setTranslationDate(editingTranslation.translationDate || '');
      setStatus(getTranslationStatusOption(editingTranslation));
      setAuthor(editingTranslation.author || '');
      setFundedBy(editingTranslation.fundedBy || '');
      setMethod(editingTranslation.method || '');
      // Set payment type based on fee
      const existingFee = editingTranslation.fee || editingTranslation.fees;
      if (existingFee && existingFee > 0) {
        setPaymentType('paid');
        setFee(existingFee.toString());
      } else {
        setPaymentType('free');
        setFee('');
      }
      setIsLocked(editingTranslation.isLocked || false);
      setCertified(!!editingTranslation.certified);
      setTranslationFile(null);
      setMethodologyFile(null);
    } else {
      // Reset form when not editing
      setCoaName(currentCoaName || '');
      setLocaleTag('');
      setTerritory('');
      setIsSourceVersion(false);
      setContinent('');
      setCountry('');
      setLanguage('');
      setTranslationDate('');
      setStatus('In Development');
      setAuthor('');
      setFundedBy('');
      setMethod('');
      setPaymentType('free');
      setFee('');
      setIsLocked(false);
      setCertified(false);
      setTranslationFile(null);
      setMethodologyFile(null);
      setAvailableCountries([]);
    }
  }, [editingTranslation, currentCoaName]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleSubmit = () => {
    if (!country.trim() || !language.trim()) {
      alert('Please fill in Country and Language');
      return;
    }

    // Determine if translation should be locked
    const feeValue = paymentType === 'paid' && fee ? parseFloat(fee) : 0;
    // Use checkbox value - admin can lock even free translations
    // If paid and fee > 0, default to locked unless explicitly unchecked
    const shouldLock = feeValue > 0 ? (isLocked !== false) : isLocked;
    
    const newTranslation = {
      coaName,
      localeTag: localeTag.trim(),
      territory,
      isSourceVersion,
      continent,
      country,
      language,
      translationDate,
      status,
      author,
      fundedBy,
      method,
      paymentType,
      fee: feeValue,
      isLocked: shouldLock,
      certified,
      translationFile,
      methodologyFile,
      translationFileUrl: existingTranslationFileUrl,
      methodologyFileUrl: existingMethodologyFileUrl
    };

    onAdd(newTranslation);
    
    // Reset form
    setLocaleTag('');
    setTerritory('');
    setIsSourceVersion(false);
    setContinent('');
    setCountry('');
    setLanguage('');
    setTranslationDate('');
    setStatus('In Development');
    setAuthor('');
    setFundedBy('');
    setMethod('');
    setPaymentType('free');
    setFee('');
    setIsLocked(false);
    setCertified(false);
    setTranslationFile(null);
    setMethodologyFile(null);
    onClose();
  };

  const handleFileChange = (e, fileType) => {
    const file = e.target.files[0];
    if (file) {
      if (fileType === 'translation') {
        setTranslationFile(file);
      } else {
        setMethodologyFile(file);
      }
    }
  };

  const handleDragEnter = (e, fileType) => {
    e.preventDefault();
    e.stopPropagation();
    if (fileType === 'translation') {
      setIsDraggingTranslation(true);
    } else {
      setIsDraggingMethodology(true);
    }
  };

  const handleDragLeave = (e, fileType) => {
    e.preventDefault();
    e.stopPropagation();
    // Leaving child nodes (icon/text) inside the zone fires dragleave on the parent — ignore those.
    const next = e.relatedTarget;
    if (next && e.currentTarget.contains(next)) {
      return;
    }
    if (fileType === 'translation') {
      setIsDraggingTranslation(false);
    } else {
      setIsDraggingMethodology(false);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      e.dataTransfer.dropEffect = 'copy';
    } catch {
      /* ignore */
    }
  };

  const handleDrop = (e, fileType) => {
    e.preventDefault();
    e.stopPropagation();
    if (fileType === 'translation') {
      setIsDraggingTranslation(false);
    } else {
      setIsDraggingMethodology(false);
    }
    const file = e.dataTransfer.files[0];
    if (file) {
      if (fileType === 'translation') {
        setTranslationFile(file);
      } else {
        setMethodologyFile(file);
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="bg-white rounded-2xl w-full max-w-4xl shadow-2xl max-h-[90vh] overflow-y-auto">
        {/* Modal Content */}
        <div className="p-10">
          {/* Header */}
          <div className="flex items-center justify-between mb-10">
            <h2 className="text-2xl font-semibold text-gray-900">
              {editingTranslation ? 'Edit Translation' : 'Add Translation'}
            </h2>
            <button
              onClick={onClose}
              className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>

          {/* Form Content */}
          <div className="space-y-8">
            {/* COA name (stored on translation; shown to customers in library) */}
            <div>
              <label className="block text-sm font-normal text-gray-700 mb-2">
                COA name
              </label>
              <input
                type="text"
                value={coaName}
                onChange={(e) => setCoaName(e.target.value)}
                className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition-all"
                placeholder="e.g. instrument title as it should appear with this translation"
              />
              <p className="mt-1 text-xs text-gray-500">
                Defaults to this COA&apos;s name if left unchanged. Edit to override how the COA is labelled for this translation.
              </p>
            </div>

            <div>
              <label className="block text-sm font-normal text-gray-700 mb-2">
                Tag
              </label>
              <input
                type="text"
                value={localeTag}
                onChange={(e) => setLocaleTag(e.target.value)}
                className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition-all"
                placeholder="e.g. Pre-operative"
              />
              <p className="mt-1 text-xs text-gray-500">
                Shown next to the language in the customer app (e.g. Dutch — Pre-operative).
              </p>
            </div>

            {/* Row 0: Territory & Is Source Version */}
            <div className="grid grid-cols-2 gap-6 mb-6">
          

              <div className="flex items-end">
                <label className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isSourceVersion}
                    onChange={(e) => setIsSourceVersion(e.target.checked)}
                    className="w-5 h-5 text-emerald-400  border-gray-300 rounded focus:ring-2 focus:ring-emerald-400 cursor-pointer"
                  />
                  <span className="text-sm font-bold text-gray-700">
                    Is Source Version
                  </span>
                </label>
              </div>
            </div>

            {/* Certified */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">
                Certified
              </label>
              <div className="flex gap-6">
                <label className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="radio"
                    name="certified"
                    value="yes"
                    checked={certified === true}
                    onChange={() => setCertified(true)}
                    className="w-5 h-5 text-emerald-400 border-gray-300 focus:ring-emerald-400 cursor-pointer"
                  />
                  <span className="text-sm text-gray-700 font-medium">Yes</span>
                </label>
                <label className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="radio"
                    name="certified"
                    value="no"
                    checked={certified === false}
                    onChange={() => setCertified(false)}
                    className="w-5 h-5 text-emerald-400 border-gray-300 focus:ring-emerald-400 cursor-pointer"
                  />
                  <span className="text-sm text-gray-700 font-medium">No</span>
                </label>
              </div>
            </div>

            {/* Row 1: Continent & Country */}
            <div className="grid grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-normal text-gray-700 mb-2">
                  Continent
                </label>
                <select
                  value={continent}
                  onChange={(e) => setContinent(e.target.value)}
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition-all appearance-none"
                  style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%236B7280' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 1rem center',
                    paddingRight: '2.5rem'
                  }}
                >
                  <option value="">Select</option>
                  <option value="Africa">Africa</option>
                  <option value="Asia">Asia</option>
                  <option value="Europe">Europe</option>
                  <option value="North America">North America</option>
                  <option value="South America">South America</option>
                  <option value="Oceania">Oceania</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-normal text-gray-700 mb-2">
                  Country
                </label>
                <select
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  disabled={!continent}
                  className={`w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition-all appearance-none ${
                    !continent ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
                  style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%236B7280' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 1rem center',
                    paddingRight: '2.5rem'
                  }}
                >
                  <option value="">{continent ? 'Select Country' : 'Select Continent First'}</option>
                  {availableCountries.map(countryName => (
                    <option key={countryName} value={countryName}>{countryName}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Row 2: Language & Translation Date */}
            <div className="grid grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-normal text-gray-700 mb-2">
                  Language
                </label>
                <select
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition-all appearance-none"
                  style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%236B7280' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 1rem center',
                    paddingRight: '2.5rem'
                  }}
                >
                  <option value="">Select Language</option>
                  {ALL_LANGUAGES.map(lang => (
                    <option key={lang} value={lang}>{lang}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-normal text-gray-700 mb-2">
                Territory (or territories) you plan to use the COA in

                </label>
                <input
                  type="text"
                  value={territory}
                  onChange={(e) => setTerritory(e.target.value)}
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition-all"
                  placeholder="Enter territory or territories"
                />
              </div>

          
            </div>

            {/* Row 3: Status & Author */}
            <div className="grid grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-normal text-gray-700 mb-2">
                  Status
                </label>
                <select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition-all appearance-none"
                  style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%236B7280' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 1rem center',
                    paddingRight: '2.5rem'
                  }}
                >
                  {/* <option value="Pending">Pending</option> */}
                  <option value="Approved">Available</option>
                  {/* <option value="Rejected">Rejected</option> */}
                  <option value="In Development">In Development</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-normal text-gray-700 mb-2">
                  Translation Date
                </label>
                <div className="relative">
                  <input
                    type="date"
                    value={translationDate}
                    onChange={(e) => setTranslationDate(e.target.value)}
                    className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition-all"
                    placeholder="DD / MM / YYYY"
                  />
                </div>
              </div>

           
            </div>

            {/* Row 4: Funded by & Method */}
            <div className="grid grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-normal text-gray-700 mb-2">
                  Funded by
                </label>
                <input
                  type="text"
                  value={fundedBy}
                  onChange={(e) => setFundedBy(e.target.value)}
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition-all"
                  placeholder=""
                />
              </div>
              <div>
                <label className="block text-sm font-normal text-gray-700 mb-2">
                  Author
                </label>
                <input
                  type="text"
                  value={author}
                  onChange={(e) => setAuthor(e.target.value)}
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition-all"
                  placeholder=""
                />
              </div>

              <div>
                <label className="block text-sm font-normal text-gray-700 mb-2">
                  Method
                </label>
                <input
                  type="text"
                  value={method}
                  onChange={(e) => setMethod(e.target.value)}
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition-all"
                  placeholder=""
                />
              </div>
            </div>

            {/* Payment Type & Fee */}
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  Payment Type
                </label>
                <div className="flex gap-6">
                  <label className="flex items-center gap-3 cursor-pointer">
                    <input
                      type="radio"
                      name="paymentType"
                      value="free"
                      checked={paymentType === 'free'}
                      onChange={(e) => {
                        setPaymentType(e.target.value);
                        setFee('');
                      }}
                      className="w-5 h-5 text-emerald-400 border-gray-300 focus:ring-emerald-400 cursor-pointer"
                    />
                    <span className="text-sm text-gray-700 font-medium">Free</span>
                  </label>
                  <label className="flex items-center gap-3 cursor-pointer">
                    <input
                      type="radio"
                      name="paymentType"
                      value="paid"
                      checked={paymentType === 'paid'}
                      onChange={(e) => setPaymentType(e.target.value)}
                      className="w-5 h-5 text-emerald-400 border-gray-300 focus:ring-emerald-400 cursor-pointer"
                    />
                    <span className="text-sm text-gray-700 font-medium">Paid</span>
                  </label>
                </div>
              </div>
              {paymentType === 'paid' && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Fee
                  </label>
                  <input
                    type="number"
                    value={fee}
                    onChange={(e) => {
                      setFee(e.target.value);
                      // Auto-lock if fee is set
                      const feeValue = parseFloat(e.target.value) || 0;
                      if (feeValue > 0) {
                        setIsLocked(true);
                      }
                    }}
                    className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition-all"
                    placeholder="Enter fee amount"
                    min="0"
                    step="0.01"
                  />
                </div>
              )}
              
              {/* Lock Checkbox - Show for both free and paid */}
              <div>
                <label className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isLocked}
                    onChange={(e) => setIsLocked(e.target.checked)}
                    className="w-5 h-5 text-emerald-400 border-gray-300 rounded focus:ring-2 focus:ring-emerald-400 cursor-pointer"
                  />
                  <span className="text-sm font-medium text-gray-700">
                    Lock {paymentType === 'paid' ? '(Requires payment to access)' : '(Restrict access)'}
                  </span>
                </label>
                <p className="text-xs text-gray-500 mt-1 ml-8">
                  {paymentType === 'paid' 
                    ? 'Locked translations are only accessible after payment is completed'
                    : 'Locked translations require admin approval or payment to access'}
                </p>
              </div>
            </div>

            {/* Row 5: File Uploads */}
            <div className="grid grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-normal text-gray-700 mb-2">
                  Translation File
                </label>
                <div
                  className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors cursor-pointer ${
                    isDraggingTranslation
                      ? 'border-emerald-500 bg-emerald-50'
                      : 'border-emerald-400 hover:border-emerald-500 bg-white'
                  }`}
                  onDragEnter={(e) => handleDragEnter(e, 'translation')}
                  onDragOver={handleDragOver}
                  onDragLeave={(e) => handleDragLeave(e, 'translation')}
                  onDrop={(e) => handleDrop(e, 'translation')}
                  onClick={() => translationInputRef.current?.click()}
                >
                  <input
                    ref={translationInputRef}
                    type="file"
                    id="translationFileInput"
                    className="hidden"
                    onChange={(e) => handleFileChange(e, 'translation')}
                  />
                  <div className="flex flex-col items-center gap-2">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M12 15V3M12 3L7 8M12 3L17 8" stroke="#40C191" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M2 17L2.621 19.485C2.72915 19.9177 2.97882 20.3018 3.33033 20.5763C3.68184 20.8508 4.11501 21.0002 4.561 21H19.439C19.885 21.0002 20.3182 20.8508 20.6697 20.5763C21.0212 20.3018 21.2708 19.9177 21.379 19.485L22 17" stroke="#40C191" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span className="text-sm text-emerald-600 font-medium">Drag & Drop</span>
                    {translationFile ? (
                      <p className="text-xs text-gray-600 mt-1">{translationFile.name}</p>
                    ) : existingTranslationFileUrl ? (
                      <div className="mt-1">
                        <p className="text-xs text-gray-500 mb-1">Already uploaded</p>
                        <a
                          href={existingTranslationFileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-xs text-emerald-600 font-medium hover:underline"
                          onClick={(e) => e.stopPropagation()}
                        >
                          View current file
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-normal text-gray-700 mb-2">
                  Methodology Form / Letter of Certification
                </label>
                <div
                  className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors cursor-pointer ${
                    isDraggingMethodology
                      ? 'border-emerald-500 bg-emerald-50'
                      : 'border-emerald-400 hover:border-emerald-500 bg-white'
                  }`}
                  onDragEnter={(e) => handleDragEnter(e, 'methodology')}
                  onDragOver={handleDragOver}
                  onDragLeave={(e) => handleDragLeave(e, 'methodology')}
                  onDrop={(e) => handleDrop(e, 'methodology')}
                  onClick={() => methodologyInputRef.current?.click()}
                >
                  <input
                    ref={methodologyInputRef}
                    type="file"
                    id="methodologyFileInput"
                    className="hidden"
                    onChange={(e) => handleFileChange(e, 'methodology')}
                  />
                  <div className="flex flex-col items-center gap-2">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M12 15V3M12 3L7 8M12 3L17 8" stroke="#40C191" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M2 17L2.621 19.485C2.72915 19.9177 2.97882 20.3018 3.33033 20.5763C3.68184 20.8508 4.11501 21.0002 4.561 21H19.439C19.885 21.0002 20.3182 20.8508 20.6697 20.5763C21.0212 20.3018 21.2708 19.9177 21.379 19.485L22 17" stroke="#40C191" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span className="text-sm text-emerald-600 font-medium">Drag & Drop</span>
                    {methodologyFile ? (
                      <p className="text-xs text-gray-600 mt-1">{methodologyFile.name}</p>
                    ) : existingMethodologyFileUrl ? (
                      <div className="mt-1">
                        <p className="text-xs text-gray-500 mb-1">Already uploaded</p>
                        <a
                          href={existingMethodologyFileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-xs text-emerald-600 font-medium hover:underline"
                          onClick={(e) => e.stopPropagation()}
                        >
                          View current file
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="flex justify-end gap-4 mt-10">
            <button
              onClick={onClose}
              className="px-6 py-3 border border-gray-300 text-gray-700 text-base font-medium rounded-xl hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-6 py-3 bg-emerald-400 text-white text-base font-medium rounded-xl hover:bg-emerald-500 transition-colors shadow-sm"
            >
              {editingTranslation ? 'Update Translation' : 'Add Translation'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTranslationModal;

